import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import ExpressJS from '../../assets/images/content/express_logo.jpg';
import MongoDB from '../../assets/images/content/mongodb_logo.png';
import NodeJS from '../../assets/images/content/node_logo.png';
import { Image } from './styles/aboutStyles';

const About = props => {
  return (
    <Container fluid className='py-5 bg-light'>
      <Container>
        <h3 className='text-center mb-5'>
          Front End Focused <br /> with Full Stack Experience
        </h3>

        <Row>
          <Col lg={6} md={6} sm={12} className='mb-3'>
            <p className='lead text-muted text-uppercase'>
              Motivated to produce results
            </p>
            <p>
              As a tenacious self-taught programmer, I use continuous iteration
              to produce results quickly and continuously improve products.
            </p>
            <p className='lead text-muted text-uppercase'>Geek</p>
            <p>I always stay attuned to the newest frameworks.</p>
          </Col>
          <Col lg={6} md={6} sm={12} className='mb-3'>
            <Row className='align-items-center h-100'>
              <Col lg={4} md={4} sm={12} className='mb-3'>
                <Image src={ExpressJS} alt='' className='shadow bg-white' />
              </Col>
              <Col lg={4} md={4} sm={12} className='mb-3'>
                <Image src={MongoDB} alt='' className='shadow bg-white' />
              </Col>
              <Col lg={4} md={4} sm={12} className='mb-3'>
                <Image src={NodeJS} alt='' className='shadow bg-white' />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default About;
